import { showError } from "../components/ErrorPopup";
import React, { useEffect, useState } from "react";
// import { FiTrash2 } from "react-icons/fi"; // Import icons from react-icons
import UsersList from "../components/UsersList";
import Grouproleschema from "../components/Grouproleschema";
import { io } from "socket.io-client";
import { getBackendToken } from "../utils/authUtils";
import { apiFetch } from '../utils/apiClient';

const socket = io.connect(`${process.env.REACT_APP_API_BASE_URL}`); // Adapter l'URL si nécessaire

function GroupRoles({ routesConfig, setRoutesConfig }) {
  const [roles, setRoles] = useState({});
  // const [loading, setLoading] = useState(true);
  // const [error, setError] = useState(null);
  const [nom, setNom] = useState("");
  const [duplicateMessage, setDuplicateMessage] = useState(false);
  const [successMessage, setSuccessMessage] = useState(false);



  // État pour stocker les données du formulaire
  const [formData, setFormData] = useState({
    userId: "",
    email: "",
    nom: "",
    group: "",
  });

  const groupOptions = [
    { value: "Administration", label: "Administration" },
    { value: "Changement adresse", label: "Changement adresse" },
    { value: "Changement de nom", label: "Changement de nom" },
    { value: "Accès au compte informatique", label: "Accès au compte informatique" },
    { value: "Changement information bancaire", label: "Changement information bancaire" },
    { value: "Antécédents criminels", label: "Antécédents criminels" },
    { value: "Réclamation mensuelle de dépenses", label: "Réclamation mensuelle de dépenses" },
    { value: "Séance de placement", label: "Séance de placement" },
    { value: "Entente de travail en mode hybrid", label: "Entente de travail en mode hybrid" },
    { value: "Consultation Achat équipement informatique", label: "Consultation – Achat équipement informatique" },
  ];

  useEffect(() => {
    
    // socket.emit("getAllRoles")
    const fetchRolesWithAuth = async () => {
    const token = await getBackendToken(); // récupère le token backend
    socket.emit("getAllRoles", { token });
  };

  fetchRolesWithAuth();

    socket.on("updateRoles", (data) => {
      setRoles(data);
    });
  
    socket.on("error", (err) => {
      console.error("Error from server:", err);
    });
  
    socket.on("disconnect", () => {
      console.log("Disconnected from socket server");
    });
  
    return () => {
      socket.off("updateRoles");
      socket.off("error");
      socket.off("connect");
      socket.off("disconnect");
    };
  });
  

  

  const handleUserSelect = (user) => {
    // console.log(user);
    setNom(user.displayName);
    setFormData((prevData) => ({
      ...prevData,
      userId: user.id,
      email: user.mail,
      nom: user.displayName,
    }));
  };

  const handleGroupChange = (event) => {
    setFormData((prevData) => ({
      ...prevData,
      group: event.target.value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    // console.log(formData);
    // Check if user already exists in the group
    const userExists = roles.some(
      (role) => role.userId === formData.userId && role.group === formData.group
    );

    if (userExists) {
      setDuplicateMessage(true);
      
      // Hide the message after 3 seconds
      setTimeout(() => {
        setDuplicateMessage(false);
      }, 1000);

      return; // Stop further execution
    }
    try {
      const response = await apiFetch(`${process.env.REACT_APP_API_BASE_URL}/addRole`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });
        
       const data = await response.json();
          if (!response.ok) {
            throw new Error(data.error || data.message);
          }
        // const result = await response.json();
        // Refresh roles after adding a new one

        // Show success message temporarily
        setSuccessMessage(true);
        setTimeout(() => {
          setSuccessMessage(false);
        }, 1000);
     
    } catch (err) {
      console.error(err);
      alert(err.message); // ou setError(err.message)
    }
  };

  // const groupedRoles = roles.reduce((acc, role) => {
  //   (acc[role.group] = acc[role.group] || []).push(role);
  //   return acc;
  // }, {});

  const groupedRoles = Array.isArray(roles) ? 
  roles.reduce((acc, role) => {
    (acc[role.group] = acc[role.group] || []).push(role);
    return acc;
  }, {}) 
  : {};

  const toggleRoute = async (route) => {
  // basculer enabled en local
  const updated = { ...route, enabled: !route.enabled };

  setRoutesConfig(prev =>
    prev.map(r =>
      r.path === route.path ? updated : r
    )
  );

  try {
    // envoyer la mise à jour au backend
    const response = await apiFetch(`${process.env.REACT_APP_API_BASE_URL}/routeUpdate`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        path: updated.path,
        enabled: updated.enabled,
        label: updated.label, // 🔹 si tu veux stocker aussi le label
      }),
    });
    
    const data = await response.json();
          if (!response.ok) {
            throw new Error(data.error || data.message);
          }
  } catch (error) {
        console.error(error);
        showError(error); // ou setError(error.message)
      }
};

  return (
    <div className="p-8 bg-gray-100 min-h-screen overflow-auto pb-10">
      <h1 className="text-3xl font-bold text-center text-gray-800 mb-8">
        Group Roles
      </h1>
      {/* Form to add a new person */}
      {duplicateMessage && (
        <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center z-50">
          <div className="p-4 bg-white rounded-lg shadow-lg">
            <p className="text-lg text-red-700">Cet utilisateur est déjà dans ce groupe.</p>
          </div>
        </div>
      )}
      {successMessage && (
        <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center z-50">
          <div className="p-4 bg-white rounded-lg shadow-lg">
            <p className="text-lg text-green-700">Utilisateur ajouté avec succès !</p>
          </div>
        </div>
      )}





      <div className="p-6 bg-gray-100 min-h-screen">
  {/* Gestion des routes */}
<div className="mb-10 ">
  <div className="flex items-center justify-between mb-6 ">
    <h2 className="text-2xl font-semibold text-gray-800 flex items-center gap-2">
      <span className="text-blue-500">⚙️</span> Gestion des routes
    </h2>
    <span className="text-sm text-gray-500">
      {routesConfig.length} route(s) disponible(s)
    </span>
  </div>

  <div className="space-y-4 ">
    {routesConfig
      
      .map(routeConfig => (
        <div
          key={routeConfig.path}
          className="flex items-center justify-between bg-white border border-gray-200 rounded-2xl p-5 shadow-sm hover:shadow-md transition-all duration-300"
        >
          <div>
            <h3 className="text-base font-semibold text-gray-800">{routeConfig.label}</h3>
            <p className="text-xs text-gray-500 mt-1">{routeConfig.path}</p>
          </div>

          <button
            onClick={() => toggleRoute(routeConfig)}
            className={`px-5 py-1.5 rounded-full text-sm font-medium transition-all duration-300 ${
              routeConfig.enabled
                ? "bg-green-500 hover:bg-green-600 text-white shadow"
                : "bg-red-500 hover:bg-red-600 text-white shadow"
            }`}
          >
            {routeConfig.enabled ? "Activé" : "Désactivé"}
          </button>
        </div>
      ))}
  </div>
</div>
      <form
  onSubmit={handleSubmit}
  className="mb-8 flex flex-col w-1/2 bg-white p-6 border rounded-lg shadow-md"
>
  <h2 className="text-xl font-bold mb-6 text-gray-800">Ajouter un utilisateur</h2>

  <label className="mb-2 font-semibold text-gray-700">Email:</label>
  <div className="mb-4 w-[60%]">
    <UsersList onUserSelect={handleUserSelect} />
  </div>

  <label className="mb-2 font-semibold text-gray-700">Nom:</label>
  <input
    type="text"
    value={nom}
    disabled
    className="mb-4 w-[60%] p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
    required
  />

  <label className="mb-2 font-semibold text-gray-700">Groupe:</label>
  <select
    value={formData.group}
    onChange={handleGroupChange}
    className="mb-4 w-[60%] p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
    required
  >
    <option value="">Sélectionner un groupe</option>
    {groupOptions.map((group, index) => (
      <option key={index} value={group.value}>
        {group.label}
      </option>
    ))}
  </select>

  <button
    type="submit"
    className="bg-blue-600 w-1/6 text-white p-2 rounded hover:bg-blue-700 transition"
  >
    Ajouter
  </button>
</form> 

      {Object.entries(groupedRoles).map(([groupName, groupRoles]) => (
        <Grouproleschema
          key={groupName}
          roles={groupRoles}
          groupName={groupName}
        />
      ))}</div>

      {/* Group Test Roles */}
      {/* <h2 className="mt-6 text-2xl font-semibold text-blue-600">Group Test Roles</h2>
      <div className="space-y-4 mb-6">
        {roles.listGroupTest.map((role, index) => (
          <div key={`test-${index}`} className="flex flex-col w-1/2 p-4 bg-white border rounded-lg shadow-md transition hover:shadow-lg">
            <div className="flex mb-1">
              <span className="font-semibold text-gray-700">Nom:</span>
              <span className="pl-2 text-gray-600">{role.nom}</span>
            </div>
            <div className="flex mb-1">
              <span className="font-semibold text-gray-700">Email:</span>
              <span className="pl-2 text-gray-600">{role.email}</span>
            </div>
            <button onClick={() => handleDelete(role.userId)} className="text-red-500 hover:text-red-700 transition duration-200 mt-2">
              <FiTrash2 />
            </button>
          </div>
        ))}
      </div> */}

      {/* Group Roles Adresse */}
      {/* <h2 className="mt-6 text-2xl font-semibold text-green-600">Group Roles Adresse</h2>
      <div className="space-y-4 mb-6">
        {roles.listGroupRolesAdresse.map((role, index) => (
          <div key={`adresse-${index}`} className="flex flex-col w-1/2 p-4 bg-white border rounded-lg shadow-md transition hover:shadow-lg">
            <div className="flex mb-1">
              <span className="font-semibold text-gray-700">Nom:</span>
              <span className="pl-2 text-gray-600">{role.nom}</span>
            </div>
            <div className="flex mb-1">
              <span className="font-semibold text-gray-700">Email:</span>
              <span className="pl-2 text-gray-600">{role.email}</span>
            </div>
            <button onClick={() => handleDelete(role.userId)} className="text-red-500 hover:text-red-700 transition duration-200 mt-2">
              <FiTrash2 />
            </button>
          </div>
        ))}
      </div>*/}

      {/* <Grouproleschema roles={roles} groupName={"listGroupTest"}></Grouproleschema>  */}
    </div>
  );
}

export default GroupRoles;
